import React from 'react';

import { EMPTY_FUNCTION } from '@travel/traveler-core/constants';

import cx from '../../utils/classnames';

import styles from './tagFilter.module.scss';

import type { CSSProperties, Ref } from 'react';

type Props = {
  /** The value assigned to the tag **/
  value?: string;
  /** Flag to define whether it is checked or not **/
  isChecked?: boolean;
  /** Function to handle click event for the tag **/
  onClick?: () => void;
  style?: CSSProperties;
  customClass?: string;
  testId?: string;
  selectedTagClass?: string;
  /** ref of button */
  innerRef?: Ref<HTMLButtonElement>;
  /** RAT info **/
  dataRatId?: string;
  dataRatEvent?: string;
  dataRatParam?: string;
};

function FilterTag(props: Props) {
  const {
    value = '',
    isChecked = false,
    onClick = EMPTY_FUNCTION,
    style,
    customClass,
    testId,
    selectedTagClass,
    innerRef,
    dataRatId,
    dataRatEvent,
    dataRatParam,
  } = props;
  return (
    <button
      className={cx(
        styles.tag,
        customClass,
        isChecked ? (selectedTagClass ? selectedTagClass : styles.selected) : styles.default,
      )}
      onClick={onClick}
      style={style}
      data-testid={testId || 'filter-tags'}
      ref={innerRef}
      data-ratid={dataRatId}
      data-ratevent={dataRatEvent}
      data-ratparam={dataRatParam}
    >
      {value}
    </button>
  );
}

export default FilterTag;
